/*
 * File: useLogin.js
 * Project: mp-mobile-app
 *
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the login form submission by making sure admin/password will not work
 * and will call the api. Also checks to make sure that the login/password are correct
 */
import { useState } from "react";
import LoginApi from "../Api";
import AppStore from "Store";
import { useStore } from "utils/useStore";
import Users from "services/users/Users";

export default onSuccess => {
  const [valid, setValid] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  const [error, setError] = useState(null);
  const [wasAutoLoggedOut, setWasAutoLoggedOut] = useState(false);
  const users = useStore(Users);
  const appStore = useStore(AppStore);

  // handles login form submit
  let onSubmit = async e => {
    e.preventDefault();

    setError(null);
    setLoggingIn(true);

    let username = e.target.username.value;
    let password = e.target.password.value;

    if (
      username.toLowerCase() === "admin" &&
      password.toLowerCase() === "password"
    ) {
      // prevent admin/password from being a valid login
      setError("Admin and password has been disabled from this app");
      setLoggingIn(false);
      return;
    }

    let nextValid = false;
    try {
      let validLogin = await LoginApi.login(username, password);

      if (validLogin) {
        await appStore.setUser(users);
        nextValid = true;

        setError(null);
        setWasAutoLoggedOut(false);
      } else {
        setError(
          "The Username and/or Password entered is incorrect. Please try again."
        );
      }
    } catch (error) {
      setError("An error occurred, please confirm that the server is running.");
    }

    setLoggingIn(false);
    setValid(nextValid);

    if (nextValid) {
      // This callback may cause the encolosing component to unmount. Calling setState functions after unmount produces warnings, so call this after all of the setState calls.
      onSuccess();
    }
  };

  return {
    valid: valid,
    error: error,
    loggingIn: loggingIn,
    wasAutoLoggedOut: wasAutoLoggedOut,
    setAutoLoggedOut: () => setWasAutoLoggedOut(true),
    onSubmit
  };
};
